import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import { injectIntl, FormattedMessage } from 'react-intl';

// Component
import SeeAll from '../../Home/SeeAll';
import CommonListingItems from '../../Common/ImageUploadComponent/CommonListingItems/CommonListingItems';
import HomeSliderSkeleton from '../../Skeleton/HomeSliderSkeleton';
// Helper
import { isRTL } from '../../../helpers/formatLocale';
import messages from '../../../locale/messages';

// Style
import cs from 'swiper/swiper-bundle.css';
import s from './HomeSlider.css';
import t from '../../../styles/customSwiper.css';

const HomeSlider = ({
  data = [],
  intl: { locale },
  isRecommand,
  hideHeading,
  fromPage,
  isViewListing,
  viewListingSimilarItem,
  skeletonClass,
  heading
}) => {
  const [localLoading, setLocalLoading] = useState(true);
  const [isClient, setIsClient] = useState(false);
  let loadSync = null;

  // Initialize Swiper packages only on client-side
  const swiperPackage = typeof window !== 'undefined' ? require('swiper/react') : null;
  const swiperModule = typeof window !== 'undefined' ? require('swiper/modules') : null;
  const { Swiper, SwiperSlide } = swiperPackage || {};
  const { Pagination } = swiperModule || {};

  useEffect(() => {
    setIsClient(true);
    setLocalLoading(false);

    return () => {
      if (loadSync) clearTimeout(loadSync);
    };
  }, []);

  useEffect(() => {
    if (loadSync) clearTimeout(loadSync);
    setLocalLoading(true);

    loadSync = setTimeout(() => {
      setLocalLoading(false);
    }, 3000);

    return () => {
      if (loadSync) clearTimeout(loadSync);
    };
  }, [locale]);

  const sliderData = data?.filter(item => item?.listPhotos?.length > 0);

  const params = {
    slidesPerView: 1,
    spaceBetween: 15,
    freeMode: true,
    breakpoints: {
      320: { slidesPerView: 1 },
      641: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
       992: { slidesPerView: fromPage === 'viewProfile' ? 2 : 6 },
      // if change breakpoint also change skeleton css breakpoint in app-common.css
    }
  };

  const renderSliderContent = () => (
    <div className={s.mostViewSwiperContainer}>
      <Swiper modules={[Pagination]} {...params} rtl={isRTL(locale)} className={cx('row homeSlickSlider', s.noMargin)}>
        {sliderData?.map((item, key) => (
          <SwiperSlide key={key}>
            <CommonListingItems
              key={key}
              id={item.id}
              title={item.title}
              basePrice={item.listingData.basePrice}
              roomType={item?.settingsData[0]?.listsettings?.itemName}
              coverPhoto={item.coverPhoto}
              listPhotos={item.listPhotos}
              wishListStatus={item.wishListStatus}
              isViewListing={isViewListing}
              currency={item.listingData.currency}
              bookingType={item.bookingType}
              reviewsCount={item.reviewsCount}
              reviewsStarRating={item.reviewsStarRating}
              beds={item.beds}
              userId={item?.user?.id}
              city={item?.city}
              state={item?.state}
            />
          </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );

  return (
    <Grid fluid>
      <div className={cx('homeSwiper', s.marginTop, viewListingSimilarItem)}>
        {!hideHeading &&
          <div className={s.sliderHeadingFlex}>
            <h3 className={cx(s.containerTitle,)}>
              {heading || (isRecommand ? <FormattedMessage {...messages.recommended} /> : <FormattedMessage {...messages.mostViewed} />)}
            </h3>
            <SeeAll />
          </div>
        }
        {localLoading &&
          <div className={skeletonClass}>
            {[1, 2, 3, 4]?.map((item, index) => {
              return (
                <HomeSliderSkeleton key={index} />
              )
            })}
          </div>
        }
        {!localLoading && isClient && renderSliderContent()}
      </div>
    </Grid>
  );
};

HomeSlider.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    listPhotos: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    })),
    coverPhoto: PropTypes.number,
    listingData: PropTypes.shape({
      basePrice: PropTypes.number,
      currency: PropTypes.string,
    }),
    settingsData: PropTypes.arrayOf(PropTypes.shape({
      listsettings: PropTypes.shape({
        itemName: PropTypes.string,
      }),
    })),
    id: PropTypes.number,
    beds: PropTypes.number,
    title: PropTypes.string,
    bookingType: PropTypes.string,
    reviewsCount: PropTypes.number,
    reviewsStarRating: PropTypes.number
  }))
};

export default compose(
  injectIntl,
  withStyles(cs, s, t),
)(HomeSlider);